import React, {useEffect, useState, FC} from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import {ProfileFriendItem} from "./profile-friend-item";
import AddIcon from "@mui/icons-material/Add";
import {useTranslation} from "next-i18next";
import AccountQuestionIcon from "mdi-material-ui/Account";
import Fab from "@mui/material/Fab";
import axios from "axios";
import {useSelector, useDispatch} from "../../store";
import {useAuth} from "../../hooks/use-auth";
import {getAuth} from "firebase/auth";


interface FakeFriendsInterface {
    fakeCount: number;
}

const FakeFriends = ({fakeCount}: FakeFriendsInterface) => {
    return <>{[...Array(fakeCount)].map((_, i) => {
        return <Grid key={i} item style={{
            position: "relative",
            marginRight: 2,
            marginBottom: 5,
            width: 100,
            height: 100,
            backgroundColor: "#d0d1cf",
            padding: 0
        }}>
            <AccountQuestionIcon
                sx={{
                    position: "absolute",
                    bottom: 0,
                    fontSize: 100,
                    filter: "blur(4px)"
                }}
            />
        </Grid>
    })}</>
}

export const ProfileFriends = () => {


    const {currentProfile} = useSelector((state) => state.userSession);
    const {user, isAuthenticated, isAdmin, requestFacebookFriends, hasGrantedFacebookFriends} = useAuth()


    const dispatch = useDispatch();

    const {t} = useTranslation();

    const {uid} = currentProfile;

    const [friendsArray, setFriendsArray] = useState<any[] | null>(null);


    useEffect(() => {
        const loadFriends = async () => {
            try {
                if (!user || !uid) return;

                const currentUser = getAuth().currentUser;

                if (currentUser) {
                    const token = await currentUser.getIdToken();

                    const url = `/api/users/${uid}/friends`;
                    const response = await axios.get(url, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setFriendsArray(response.data);
                }
            } catch (e) {
                console.error(e.message);
            }
        };

        loadFriends().catch(error => console.error(error));
    }, [user?.uid, uid]);

    const facebookPermissionClicked = (e: any) => {
        requestFacebookFriends()
        //console.log("fb perm clicked")
        // dispatch(requestFacebookFriendsPermission);
    };


    const isOwnProfile = isAuthenticated && user?.uid === uid;

    // const facebookFriendsData = get(profile, "facebook.userData.friends");
    const facebookFriendsData = null

    // @ts-ignore
    // @ts-ignore
    return (
        <Card elevation={0} square sx={{p: 2, border: "1px solid #d0d0d0", mb: 2}}>
            <Typography paragraph variant="h6">
                {t("my-friends")}
            </Typography>
            <Grid container spacing={0} wrap={"wrap"} justifyContent={"space-evenly"}>
                {isAuthenticated &&
                    !!friendsArray &&
                    friendsArray.map((friend, idx) => {
                        return <ProfileFriendItem key={idx} {...friend} />;
                    })}

                {isAuthenticated && !!friendsArray && friendsArray.length === 0 && (
                    <Grid item xs={12}>
                        {t("none-yet")}
                    </Grid>
                )}

                {isAuthenticated && !friendsArray && (
                    <Grid item>
                        <CircularProgress size={46}/>
                    </Grid>
                )}

                {(isAuthenticated && isOwnProfile && !hasGrantedFacebookFriends()) && (
                    <Grid
                        item
                        xs={12}
                        style={{paddingBottom: 8, paddingTop: 8, textAlign: "center"}}
                    >
                        <Fab
                            onClick={facebookPermissionClicked}
                            variant="extended"
                            color={"primary"}
                        >
                            {" "}
                            <AddIcon style={{marginBottom: 4}}/> {t("add-friends")}{" "}
                        </Fab>
                    </Grid>
                )}

                {!isAuthenticated && <FakeFriends fakeCount={3}/>}
            </Grid>
        </Card>
    );
}
